import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { gitManageSuites } from '../../docs-routes'

const ManageSuites = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Add suites from your Git repository to DAI to enable you to start using snippets managed by Git.
    </Color>
    <DocusaurusFooter path={gitManageSuites} />
  </Paragraph>

export default ManageSuites
